import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import Header from "../header";
import Footer from "../footer";
import moment from "moment";
import { toast } from "react-toastify";
import { createcompbook, detailcompbook } from "../../service/dashboard";

const AddComplaint = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [cname, setCName] = useState("");
    const [cdate, setCDate] = useState("");
    const [cphone, setCPhone] = useState("");
    const [cpriority, setCPriority] = useState("");
    const [creason, setCReason] = useState("");
    const [cfile, setCFile] = useState("");
    const [curl, setCUrl] = useState("");
    const location = useLocation();
    const [urllink, setUrllink] = useState("");
    useEffect(() => {
        const path = location.pathname.split("/")[2];
        setUrllink(path);
        setCDate(moment(new Date()).format("YYYY-MM-DD"));
        if (path === "complaintdetail") {
            detailcompbook(id).then((res) => {
                if (res.status === true) {
                    if (res.data.details !== null) {
                        setCName(res.data.details.complaint_name);
                        setCPhone(res.data.details.phone);
                        setCPriority(res.data.details.priority);
                        setCReason(res.data.details.complaint_reason);
                        if (res.data.details.complaint_file !== null) {
                            setCUrl(res.data.path + res.data.details.complaint_file);
                        }
                        setCDate(moment(res.data.details.complaint_date).format("YYYY-MM-DD"));
                    }
                }
            });
        }
    }, [location.pathname]);
    function handlePhone(e) {
        const regex = /^[0-9\b]+$/;
        if (e.target.value === "" || regex.test(e.target.value)) {
            setCPhone(e.target.value);
        }
    }

    const [photoerror, setPhotoError] = useState("");
    function photofile(event) {
        setPhotoError("");
        setCFile("");
        if (event.target.files.length !== 0) {
            if (event.target.files[0].name.match(/\.(jpg|jpeg|png|pdf)$/i)) {
                setCUrl(URL.createObjectURL(event.target.files[0]));
                setCFile(event.target.files[0]);
            } else {
                setPhotoError("Attachment should be jpg, jpeg, or png or pdf format");
            }
            var size = event.target.files[0].size / 1024 / 1024;
            if (size > 5) {
                setCFile("Attachment size should be less than 5MB");
            }
        }
    }
    const [cerror, setCError] = useState(false);
    function submitcomp(e) {
        e.preventDefault();
        setCError(true);
        if (
            cname !== "" &&
            cdate !== "" &&
            cphone !== "" &&
            cpriority !== "" &&
            creason !== ""
        ) {
            setLoading(true);
            const temp = new FormData();
            temp.append("complaint_name", cname);
            temp.append("phone", cphone);
            temp.append("priority", cpriority);
            temp.append("complaint_reason", creason);
            temp.append("complaint_file", cfile);
            temp.append("complaint_date", cdate);
                // temp.append("academy_id", acaid.value);
            if (urllink === "complaintdetail") {
                temp.append("id", id);
            }
            createcompbook(temp).then((res) => {
                if (res.status === true) {
                    setLoading(false);
                    setCError(false);
                    navigate("/complaint");
                    toast.success(res.message);
                } else {
                    setLoading(false);
                    setCError(false);
                    toast.error(res.message);
                }
            });
        }
    }

   
    const [loading, setLoading] = useState(false);

    function errorhandle(ev) {
        ev.target.src = require("../../assets/images/placeholder.png");
        ev.target.onerror = null;
    }
    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />
                <div className="moreheading">
                    <Row className="row-sm">
                        <Col xs={6} className="text-left align-self-end">
                            <h4 className="morehead-text">{urllink === "addcomplaint" ? "Add Complaint" : "Complaint Details"}</h4>
                        </Col>
                        <Col xs={6} className="text-right align-self-end">
                            <Link to={"/leavedashboard"} className="btn-outline-success red-btn btn-sm">
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </Col>
                    </Row>
                </div>
                {loading && (
                    <div className="loader-wrapper">
                        <div className="loader"></div>
                        <h3>Loading...Please do not go back or close the window.</h3>
                    </div>
                )}
                {!loading && (
                    <div className="leave-container">
                        <div className="row">
                            <div className="col-lg-3 col-md-3">
                                <div className="formapply">
                                    <label className="form-label fw-bold">Name  <span className="text-danger"> *</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Name"
                                        onChange={(e) => setCName(e.target.value)}
                                        value={cname}
                                    />
                                    {cerror && cname === "" && (
                                        <span className="text-danger">
                                            Please Enter Name
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3">
                                <div className="formapply">

                                    <label className="form-label fw-bold">Date <span className="text-danger"> *</span></label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        placeholder="Enter From Date"
                                        onChange={(e) => setCDate(e.target.value)}
                                        value={cdate}
                                    />
                                    {cerror && cdate === "" && (
                                        <span className="text-danger">
                                            Please Enter Date
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3">
                                <div className="formapply">

                                    <label className="form-label fw-bold">Phone Number <span className="text-danger"> *</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Phone Number"
                                        onChange={handlePhone}
                                        value={cphone}
                                        maxLength="10"
                                    />
                                    {cerror && cphone === "" && (
                                        <span className="text-danger">
                                            Please Enter Phone Number
                                        </span>
                                    )}

                                </div>
                            </div>

                            <div className="col-lg-3 col-md-3">
                                <div className="formapply">

                                    <label className="form-label fw-bold">Complaint Priority <span className="text-danger"> *</span></label>
                                    <select
                                        className="form-control"
                                        onChange={(e) => setCPriority(e.target.value)}
                                        value={cpriority}
                                    >
                                        <option value="" disabled>
                                            Select Complaint Priority
                                        </option>
                                        <option value="High">High</option>
                                        <option value="Medium">Medium</option>
                                        <option value="Low">Low</option>
                                    </select>
                                    {cerror && cpriority === "" && (
                                        <span className="text-danger">
                                            Please Select Complaint Priority
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-3">
                                <div className="formapply">

                                    <label className="form-label fw-bold">Complaint <span className="text-danger"> *</span></label>
                                    <textarea
                                        className="form-control"
                                        name="example-textarea-input"
                                        rows={4}
                                        placeholder="Enter Complaint"
                                        onChange={(e) => setCReason(e.target.value)}
                                        value={creason}
                                    />
                                    {cerror && creason === "" && (
                                        <span className="text-danger">
                                            Please Enter Complaint
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3">
                                <div className="formapply">

                                    <label className="form-label fw-bold">Attachment <span className="text-danger"> (Files Format: jpg, jpeg, png or pdf )</span></label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        onChange={photofile}
                                    />
                                    {photoerror !== "" && (
                                        <span className="text-danger">{photoerror}</span>
                                    )}
                                </div>
                            </div>
                            {curl !== "" && (
                                <div className="col-xl-6 col-sm-6">
                                    <div className="mb-3">
                                        {curl.split(".").pop() === "pdf" && (
                                            <a href={curl} target="_blank">
                                                <img
                                                    src={require("../../assets/images/pdf.png")}
                                                    width="150px"
                                                    height="150px"
                                                />
                                            </a>
                                        )}
                                        {curl.split(".").pop() !== "pdf" && (
                                            <a href={curl} target="_blank">
                                                <img src={curl} width="150px" height="150px" onError={errorhandle} />
                                            </a>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="text-right mb-5">
                            <button className="btn btn-success me-2" onClick={submitcomp}>
                                Submit
                            </button>
                        </div>
                    </div>
                )}

            </div>

            <Footer />
        </div>
    );
};

export default AddComplaint;
